// ---------------------------------------------------------------
// SetPasswordModal.js — Permite vincular una contraseña a la
// cuenta actual (p. ej. si entraste con Google y aún no tienes
// acceso con correo/username + contraseña).
// ---------------------------------------------------------------
import { useState } from "react";
import { linkPasswordToAccount } from "../services/authService";

const ERROR_MESSAGES = {
  "auth/weak-password": "La contraseña debe tener al menos 6 caracteres.",
  "auth/provider-already-linked":
    "Esta cuenta ya tiene contraseña. Puedes iniciar sesión con ella.",
  "auth/email-already-in-use": "Ese correo ya está en uso por otra cuenta.",
  "auth/requires-recent-login":
    "Por seguridad, cierra sesión, vuelve a entrar con Google e inténtalo de nuevo.",
};

export default function SetPasswordModal({ user, onDone, onSkip }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setSaving(true);
    try {
      await linkPasswordToAccount(user, password);
      onDone();
    } catch (err) {
      setError(
        ERROR_MESSAGES[err.code] || "No se pudo guardar la contraseña."
      );
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Establece tu contraseña</h2>
        </header>
        <form className="modal-form" onSubmit={handleSubmit}>
          <p className="modal-hint">
            Tu cuenta usa Google. Crea una contraseña para poder entrar también
            con tu correo o nombre de usuario.
          </p>
          <label className="modal-field">
            <span>Nueva contraseña</span>
            <input
              className="modal-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              autoComplete="new-password"
              required
              autoFocus
            />
          </label>
          <label className="modal-field">
            <span>Repetir contraseña</span>
            <input
              className="modal-input"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={6}
              autoComplete="new-password"
              required
            />
          </label>
          {error && <div className="modal-error">{error}</div>}
          <footer className="modal-footer">
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onSkip}>
                Más tarde
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? "Guardando…" : "Guardar contraseña"}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>
  );
}
